import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { Advisor } from "@/advisor/Advisor";
import { trackOpen } from "@/advisor/api";

const Mini = () => (
  <div className="mb-5">
    <h2 className="font-display text-2xl font-semibold leading-tight">Biznesiniz üçün <span className="text-[#D6AD62]">nə yarada</span> bilərik?</h2>
    <p className="text-sm text-[#a9a398] mt-2">Biznesinizi qısaca təsvir edin. Sizə uyğun rəqəmsal həlləri müəyyən edək.</p>
  </div>
);

export default function AdvisorLauncher() {
  const { state, drawer, setDrawer } = useAdvisor();
  const { pathname } = useLocation();
  const [bubble, setBubble] = useState(false);
  const [inView, setInView] = useState(false);
  const hidden = pathname.startsWith("/advisor") || state.selected.length > 0 || drawer || inView;

  useEffect(() => {
    const el = document.getElementById("advisor");
    if (!el) return setInView(false);
    const io = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, [pathname]);

  useEffect(() => {
    if (hidden || sessionStorage.getItem("lm_adv_bubble")) return;
    const t = setTimeout(() => setBubble(true), 7000);
    return () => clearTimeout(t);
  }, [hidden]);

  const open = (entry) => {
    trackOpen(entry);
    sessionStorage.setItem("lm_adv_bubble", "1");
    setBubble(false);
    setDrawer(true);
  };
  const closeBubble = () => {
    sessionStorage.setItem("lm_adv_bubble", "1");
    setBubble(false);
  };

  return (
    <>
      {!hidden && bubble && !drawer && (
        <div className="adv-bubble fade-up" data-testid="advisor-bubble">
          <button onClick={closeBubble} className="absolute top-2 right-2 text-[#77736B]" aria-label="Bağla" data-testid="advisor-bubble-close"><X size={14} /></button>
          <p className="font-semibold pr-4">Biznesinizə nə lazımdır?</p>
          <p className="text-[#77736B] mt-1">1 dəqiqəyə uyğun rəqəmsal həlləri tapaq. Pulsuz.</p>
          <button onClick={() => open("bubble")} className="text-[#b58a3f] font-semibold mt-2" data-testid="advisor-bubble-open">Başla →</button>
        </div>
      )}
      {!hidden && (
        <button onClick={() => open("launcher")} className="adv-launcher" data-testid="advisor-launcher" aria-label="LiveMedia Business Advisor">
          <span className="adv-launcher-icon"><Sparkles size={19} /></span>
          <span className="text-left leading-tight">
            <span className="block text-sm font-bold">Həll tap</span>
            <span className="block text-[11px] text-[#cfc9bd] max-sm:hidden">Business Advisor</span>
          </span>
        </button>
      )}
      <Sheet open={drawer} onOpenChange={setDrawer}>
        <SheetContent side="right" className="w-full sm:max-w-[520px] bg-[#111110] text-[#F3EEE4] border-[#D6AD62]/20 overflow-y-auto p-5 sm:p-6" data-testid="advisor-drawer">
          <SheetTitle className="adv-eyebrow">LiveMedia Business Advisor</SheetTitle>
          <SheetDescription className="sr-only">Biznesinizə uyğun rəqəmsal həllər</SheetDescription>
          <div className="mt-5 pb-24">
            <Advisor hero={<Mini />} compact onNavigate={() => setDrawer(false)} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
